import React from 'react';
import QrCode from './QrCode';
import logo from '../logo.png';

export const WHATSAPP_URL = 'https://chat.whatsapp.com/Ih5MrjlCXE36HY9F8ibzh0';

export default function WhatsAppBanner({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60">
      <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-2xl p-6 text-center">
        <button
          onClick={onClose}
          aria-label="Schließen"
          className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100 bg-transparent border-0 cursor-pointer text-xl leading-none"
        >
          ×
        </button>

        <img src={logo} alt="BeachLAN Hörup" className="h-12 w-auto object-contain mx-auto mb-3" />
        <h2 className="text-lg font-bold text-ocean-900 mb-2">Tritt unserer WhatsApp-Gruppe bei!</h2>
        <p className="text-sm text-slate-600 mb-4 leading-relaxed">
          Dort gibt es alle Neuigkeiten, Ankündigungen und Hilfe bei Fragen rund um die BeachLAN.
        </p>

        <div className="flex justify-center mb-4">
          <QrCode value={WHATSAPP_URL} size={160} className="rounded-lg bg-white p-2 border border-slate-200" />
        </div>

        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block w-full bg-[#25D366] hover:bg-[#1ebe5a] text-white font-semibold text-sm py-2.5 rounded-lg no-underline transition-colors"
        >
          WhatsApp-Gruppe beitreten
        </a>
      </div>
    </div>
  );
}
